import React, { type PropsWithChildren } from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/index.tsx';
import {
	ContextualAnalyticsData,
	FireScreenAnalytics,
} from '@atlassian/jira-product-analytics-bridge';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import { UpsellVisibilityCheck } from './visibility-check';

interface Props {
	variation: 'features' | 'services';
}

export const CmdbUpsellCommonBase = (props: PropsWithChildren<Props>) => {
	const { isSiteAdmin, appEditions } = useTenantContext();
	return (
		<JSErrorBoundary
			id={`${props.variation}-error-boundary`}
			packageName="cmdb-upsell-banner"
			fallback="unmount"
			teamName="falcons"
		>
			<ContextualAnalyticsData
				sourceType="Banner"
				sourceName="cmdbUpsell"
				attributes={{
					cmdbUpsellBannerVariation: props.variation,
					servicedeskEdition: appEditions.serviceDesk,
					isSiteAdmin,
				}}
			>
				<UpsellVisibilityCheck>
					{props.children}
					<FireScreenAnalytics />
				</UpsellVisibilityCheck>
			</ContextualAnalyticsData>
		</JSErrorBoundary>
	);
};
